module.exports = require("@foundit/campaignPanel");